import { getMarkerNodes } from './audio-track.helper';
import styles from '../_audio-track.module.scss';

export const useWsMarkersCb = (ws: WaveSurfer) => {
  const shadeCullCandidates = (payload?: { removedMarkers: number[]; culledMarkers: number[] }) => {
    const markerNodes = getMarkerNodes(ws);
    const regionsList = Object.values(ws.regions.list);

    markerNodes.forEach((el) => {
      (el as HTMLElement)?.classList?.remove(styles[`region--culled`]);
      (el as HTMLElement)?.classList?.remove(styles[`region--cullRemoved`]);
    });

    if (!payload) return;

    const { culledMarkers, removedMarkers } = payload;

    culledMarkers.forEach((startTime) => {
      const appropriateMarkerIndex = regionsList.findIndex((region) => region.start === startTime);

      if (appropriateMarkerIndex || appropriateMarkerIndex === 0)
        (markerNodes[appropriateMarkerIndex] as HTMLElement)?.classList?.add(styles['region--culled']);
    });
    removedMarkers.forEach((id) => (markerNodes[id] as HTMLElement)?.classList?.add(styles['region--cull_removed']));
  };

  return { shadeCullCandidates };
};
